/* OneFit quiz funnel — navigation, selection, email gate, Klaviyo submission */
(function () {
  "use strict";

  /* =====================================================================
     QUIZ FUNNEL ANALYTICS  — every step fires to BOTH:
       - GA4 (gtag): snake_case events, e.g. "quiz_popup_viewed". This is the
         GUEST funnel — GA4 is aggregate/eventful, so it reports on the many
         visitors who bounce before the email step. No identity required.
       - Klaviyo onsite (company YnKpzp): the readable "Quiz Popup ..." event.
         Klaviyo is profile-centric, so its value is the IDENTITY milestones
         (email/phone captured, completed) that identify() back-fills onto the
         real profile for flows & segments.
     One track() call drives both; analytics can never break the quiz.
  ===================================================================== */
  function gaName(name) {
    return name.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
  }
  function gaEvent(name, params) {
    try {
      if (typeof window.gtag !== "function") return;
      var clean = {};
      Object.keys(params || {}).forEach(function (k) {
        var v = params[k];
        clean[k] = Array.isArray(v) ? v.join(", ") : v;   // GA4 params must be scalar
      });
      window.gtag("event", name, clean);
    } catch (e) { /* analytics must not break the quiz */ }
  }
  function klaviyoPush(args) {
    try { window.klaviyo = window.klaviyo || []; window.klaviyo.push(args); }
    catch (e) { /* never let analytics break the quiz */ }
  }
  function track(event, props) {
    props = props || {};
    gaEvent(gaName(event), props);          // GA4 — guest funnel
    klaviyoPush(["track", event, props]);   // Klaviyo — identified-profile back-fill
  }
  function identify(props) { klaviyoPush(["identify", props || {}]); }

  /* =====================================================================
     KLAVIYO CONFIG  — fill these in to go live.
     - publicKey: your Klaviyo public API key (a.k.a. Company ID / Site ID,
       6–7 chars, e.g. "AbC123"). Found in Klaviyo > Settings > API Keys.
     - listId:   (optional) a List ID to subscribe the profile to.
     While publicKey is empty, submissions run in DRY-RUN mode: the exact
     payload is logged to the console instead of being sent.
  ===================================================================== */
  var KLAVIYO = {
    enabled: true,           // set false for dry-run: payload is logged, nothing is sent
    publicKey: "YnKpzp",     // Klaviyo public key / Site ID
    listId: "VAfCx4",        // OneFit quiz list
    /* Must be >= the revision that added `subscriptions` to the client
       subscription endpoint's profile resource. On 2024-10-15 the API replies
       "'subscriptions' is not a valid field for the resource 'profile'". */
    revision: "2026-04-15",
    /* Ask for the SMS opt-in even when the number's country isn't on Klaviyo's
       supported list. For testing only — Klaviyo rejects the whole subscription
       for an unsupported region, so the email signup falls back to a retry. */
    forceSms: true
  };

  /* Countries where Klaviyo can collect SMS consent. Asking for an SMS opt-in
     outside this set makes the WHOLE subscription call fail — taking the email
     signup down with it — so we simply don't ask.
     https://help.klaviyo.com/hc/en-us/articles/4402914866843 */
  var KLAVIYO_SMS_COUNTRIES = [
    "us", "ca",
    "at", "be", "ch", "de", "dk", "es", "fi", "fr", "gb", "hu",
    "ie", "it", "lu", "nl", "no", "pl", "pt", "se",
    "au", "nz"
  ];

  /* Set to an address to pre-fill the reveal email while testing. Must be "" in
     production or every submission carries the same address. */
  var PREFILL_EMAIL = "";

  /* Human-readable question text per answer field, so Klaviyo stores Q + A. */
  var QUESTIONS = {
    moment:      "Pick the moment you relate to the most",
    priority:    "What are you not willing to let slip?",
    supplements: "Which supplements do you currently take?"
  };

  /* =====================================================================
     RECOMMENDATION → product page. The result screen's "Continue" sends
     the user to the recommended product's page.
     TODO: wire real scoring from the answers; defaults to "onefit".
  ===================================================================== */
  var PRODUCT_URLS = {
    onefit: "/products/onefit",
    onelife: "/products/onelife-aus",
    comprehensive: "/products/comprehensive"
  };

  /* Result screen content per recommendation. `desc` is HTML — the emphasised
     phrase is bold. */
  var RESULTS = {
    onefit: {
      title: "Meet OneFit&reg;",
      image: "https://cdn.shopify.com/s/files/1/0632/2143/2504/files/90-DAY-BUNDLE-BOX_NEW-BOTTLE.png?v=1782117252",
      alt: "OneFit bundle",
      desc: "OneFit&reg; combines 31 ingredients into <strong>one single daily serve.</strong>"
    },
    onelife: {
      title: "Meet OneLife&trade;",
      image: "https://cdn.shopify.com/s/files/1/0632/2143/2504/files/OneLife_Quiz_Ed_5.png?v=1782105390",
      alt: "OneLife",
      desc: "OneLife Is Australia&rsquo;s only NMN Blend. <strong>Full Clinical Doses &amp; Third-Party Tested.</strong>"
    },
    comprehensive: {
      title: "The Complete System",
      image: "https://cdn.shopify.com/s/files/1/0632/2143/2504/files/Complete_System_OneLife_OneFit_Transparent.png?v=1782100389",
      alt: "OneFit and OneLife — the complete system",
      desc: "<strong>OneFit &amp; OneLife.</strong><br />For Today &amp; For Tomorrow."
    }
  };

  var recommendation = "onefit";
  function productUrl() { return PRODUCT_URLS[recommendation] || PRODUCT_URLS.onefit; }

  /* Paint the result screen for whatever `recommendation` resolved to. */
  function applyResult() {
    var data = RESULTS[recommendation] || RESULTS.onefit;
    var title = popup.querySelector(".fq-result__title");
    var image = popup.querySelector(".fq-result__bundle");
    var desc = popup.querySelector(".fq-result__desc");
    if (title) title.innerHTML = data.title;
    if (desc) desc.innerHTML = data.desc;
    if (image) {
      image.src = data.image;
      image.alt = data.alt;
    }
  }

  /* Supplements that sit on the OneLife side of the range. Mirrors
     `targetSupplements` in unicorn.js. Matched as substrings, case-insensitive,
     so "Ashwagandha (KSM-66)" matches "Ashwagandha". */
  var ONELIFE_SUPPLEMENTS = [
    "I’m New To Supplements", "NMN", "Electrolytes", "CoQ10",
    "Magnesium", "Ashwagandha", "L-Theanine", "Antioxidant"
  ];

  /* True when EVERY picked supplement is a OneLife-side one. Picking anything
     outside that set (protein, creatine, BCAAs…) makes this false. */
  function takesOnlyOneLifeSupplements() {
    var picked = Array.prototype.map.call(
      popup.querySelectorAll('.fq-options[data-field="supplements"] .fq-option.selected .fq-option__label'),
      function (el) { return el.textContent.trim().toLowerCase(); }
    );
    if (!picked.length) return false;   // unicorn's .every() returns true here; treat "nothing picked" as no signal
    return picked.every(function (label) {
      return ONELIFE_SUPPLEMENTS.some(function (target) {
        return label.indexOf(target.toLowerCase()) !== -1;
      });
    });
  }

  /* Score the recommendation.

     Stage 1 — Q1 and Q2 each carry a `data-product`:
       agree            -> that product (comprehensive included)
       disagree         -> comprehensive (they need both halves)

     Stage 2 — the supplements question can only ever upgrade OneFit:
       onefit  + a OneLife-only stack -> comprehensive
       onelife                        -> onelife
       comprehensive                  -> comprehensive
     Nothing is ever downgraded. */
  function scoreRecommendation() {
    var picks = Array.prototype.map.call(
      popup.querySelectorAll(".fq-option.selected[data-product]"),
      function (el) { return el.getAttribute("data-product"); }
    );
    if (!picks.length) return "onefit";

    var q1 = picks[0];                                  // first in DOM order
    var q2 = picks.length > 1 ? picks[1] : q1;
    var best = q1 === q2 ? q1 : "comprehensive";

    if (best === "onefit" && takesOnlyOneLifeSupplements()) return "comprehensive";
    return best;
  }

  var popup = document.getElementById("fq-popup-card");
  if (!popup) return;
  var stage = popup.closest(".fq-stage") || document.querySelector(".fq-stage");
  var screens = Array.prototype.slice.call(popup.querySelectorAll(".fq-screen"));
  var order = screens.map(function (s) { return s.getAttribute("data-step"); });
  var emailInput = document.getElementById("fq-reveal-email");
  var phoneInput = document.getElementById("fq-reveal-phone");
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  /* Fallback only — used when intl-tel-input's validator isn't available.
     Permissive: optional leading +, 8–20 digits/spaces/dashes/parens. */
  var PHONE_RE = /^\+?[\d\s\-().]{8,20}$/;

  /* ---- Phone: intl-tel-input + GetGeoAPI country detection ---------------
     Every part of this is optional. If the library is absent, the geo lookup
     fails, or localStorage is unavailable, the field degrades to a plain text
     input validated by PHONE_RE. It must never block the funnel. */
  var GEO = {
    url: "https://api.getgeoapi.com/v2/ip/check?api_key=6be9e5e33b3f9ee33ee7ebd401a82a65472dc1f1&format=json",
    cacheKey: "user_country_code",
    expiryKey: "user_country_code_expiry",
    ttlMs: 4 * 60 * 60 * 1000,   // 4h — matches the other theme scripts
    timeoutMs: 3000,
    fallback: "au"
  };
  var iti = null;               // intl-tel-input instance, or null

  function cachedCountry() {
    try {
      var expiry = parseInt(localStorage.getItem(GEO.expiryKey), 10);
      if (!expiry || Date.now() > expiry) return null;
      return localStorage.getItem(GEO.cacheKey) || null;
    } catch (e) { return null; }
  }

  function cacheCountry(code) {
    try {
      localStorage.setItem(GEO.cacheKey, code);
      localStorage.setItem(GEO.expiryKey, String(Date.now() + GEO.ttlMs));
    } catch (e) { /* private mode / quota — the lookup just repeats next time */ }
  }

  /* Resolves to a lowercase ISO country code. Never rejects. */
  function detectCountry() {
    var hit = cachedCountry();
    if (hit) return Promise.resolve(hit);
    if (typeof fetch !== "function") return Promise.resolve(GEO.fallback);

    /* Bound the request — a hung geo API must not stall the popup. */
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = setTimeout(function () { if (controller) controller.abort(); }, GEO.timeoutMs);

    return fetch(GEO.url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var code = data && data.country && data.country.code;
        if (!code) return GEO.fallback;
        code = String(code).toLowerCase();
        cacheCountry(code);
        return code;
      })
      .catch(function () { return GEO.fallback; })
      .then(function (code) { clearTimeout(timer); return code; });
  }

  /* Init on the fallback country (AU), then upgrade to the detected one.

     MUST run while the phone screen is visible: intl-tel-input measures the
     flag + dial-code selector to set the input's left padding, and a hidden
     screen (`display:none`) measures 0 — the "+61" then renders underneath the
     typed number. So this is called the first time the step is shown, not on
     load. Kick off the geo lookup early so the country is cached by then. */
  var geoPromise = phoneInput ? detectCountry() : null;

  /* intl-tel-input (~90KB gz, cdnjs) is lazy-loaded on the FIRST quiz open —
     most visitors never open the quiz, so the page doesn't pay for it (the
     eager tags were removed from the snippet). The CSS is inserted BEFORE
     fon-quiz-figma.css so the quiz's .iti overrides keep winning the cascade.
     If the lib lands while the phone step is already visible, init right away;
     otherwise the existing `step === "phone"` hook picks it up. Until/unless
     it loads, phoneIsValid()'s regex fallback keeps the form working. */
  var ITI_BASE = "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/25.5.2/build/";
  var itiLoadStarted = false;
  function loadPhoneLib() {
    if (itiLoadStarted || !phoneInput) return;
    itiLoadStarted = true;
    if (typeof window.intlTelInput === "function") return;   // already present

    var css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = ITI_BASE + "css/intlTelInput.min.css";
    css.integrity = "sha512-X3pJz9m4oT4uHCYS6UjxVdWk1yxSJJIJOJMIkf7TjPpb1BzugjiFyHu7WsXQvMMMZTnGUA9Q/GyxxCWNDZpdHA==";
    css.crossOrigin = "anonymous";
    css.referrerPolicy = "no-referrer";
    var quizCss = document.querySelector('link[href*="fon-quiz-figma"]');
    if (quizCss && quizCss.parentNode) quizCss.parentNode.insertBefore(css, quizCss);
    else document.head.appendChild(css);

    var s = document.createElement("script");
    s.src = ITI_BASE + "js/intlTelInputWithUtils.min.js";
    s.integrity = "sha512-WUBJ+xaDHIYMEMc1AxlKlrnsTSB2MdDYUkLxQWncmOCylseVkpqd4QNvXo18y2/GyGCoaRbBCozGbttkTtJsUA==";
    s.crossOrigin = "anonymous";
    s.referrerPolicy = "no-referrer";
    s.onload = function () {
      if (popup && popup.getAttribute("data-step") === "phone") initPhoneField();
    };
    document.head.appendChild(s);
  }

  function initPhoneField() {
    if (iti || !phoneInput || typeof window.intlTelInput !== "function") return;

    try {
      iti = window.intlTelInput(phoneInput, {
        initialCountry: GEO.fallback,
        separateDialCode: true,
        nationalMode: false,          // keep the value in international form
        autoPlaceholder: "aggressive", // show a real example number, like Klaviyo
        formatOnDisplay: true,
        strictMode: true,             // digits only, capped at the country's length
        /* The popup clips overflow, so the country list is portalled to <body>
           and lifted above the overlay in CSS (.iti--container). */
        dropdownContainer: document.body
      });
    } catch (e) {
      iti = null;   // fall back to the regex validator
      return;
    }

    geoPromise.then(function (country) {
      /* Don't yank the flag out from under someone who already started typing
         or picked a country themselves. */
      if (!iti || phoneInput.value) return;
      try { iti.setCountry(country); } catch (e) { /* keep the fallback */ }
    });
  }

  /* Klaviyo-style validation messages, keyed to intl-tel-input's error codes. */
  var PHONE_ERRORS = [
    "Enter a valid phone number",
    "Invalid country code",
    "That number is too short",
    "That number is too long",
    "Enter a valid phone number"
  ];

  function phoneError() {
    if (!iti || typeof iti.getValidationError !== "function") {
      return "Enter a valid phone number";
    }
    try {
      return PHONE_ERRORS[iti.getValidationError()] || PHONE_ERRORS[0];
    } catch (e) {
      return PHONE_ERRORS[0];
    }
  }

  /* E.164 for Klaviyo when we can produce it, raw input otherwise. */
  function phoneValue() {
    if (iti) {
      try {
        var n = iti.getNumber();
        if (n) return n;
      } catch (e) { /* fall through */ }
    }
    return (phoneInput.value || "").trim();
  }

  /* Can Klaviyo take an SMS opt-in for the number the shopper entered? */
  function smsSupported() {
    if (!iti || typeof iti.getSelectedCountryData !== "function") return false;
    try {
      var iso = (iti.getSelectedCountryData() || {}).iso2;
      return KLAVIYO_SMS_COUNTRIES.indexOf(String(iso || "").toLowerCase()) !== -1;
    } catch (e) {
      return false;
    }
  }

  function phoneIsValid() {
    if (iti && typeof iti.isValidNumber === "function") {
      try { return !!iti.isValidNumber(); } catch (e) { /* fall through */ }
    }
    return PHONE_RE.test((phoneInput.value || "").trim());
  }
  var index = 0;
  var submitted = false;
  var revealing = false;

  /* How long the reveal screen takes to dissolve before the result replaces it.
     Must stay in step with the .is-revealing transition in the CSS (0.9s). */
  var REVEAL_MS = 950;

  /* Progress shown per step (mobile). Welcome has no bar. */
  var PROGRESS = { welcome: 0, q1: 25, q2: 50, q4: 75, reveal: 85, phone: 95, result: 100 };
  var progressFill = popup.querySelector(".fq-progress__fill");
  var progressPct = popup.querySelector(".fq-progress__pct");

  /* A question's Continue button stays disabled until at least one option is
     picked. Screens with no .fq-options list (welcome, reveal, result) are exempt. */
  function syncContinue(screen) {
    var list = screen.querySelector(".fq-options");
    var btn = screen.querySelector(".fq-btn--continue");
    if (!list || !btn) return;
    btn.disabled = !list.querySelector(".fq-option.selected");
  }

  function show(i) {
    index = Math.max(0, Math.min(order.length - 1, i));
    var step = order[index];
    screens.forEach(function (s, n) {
      s.classList.toggle("is-active", n === index);
    });
    syncContinue(screens[index]);
    /* The phone field can only be measured once its screen is on-screen */
    if (step === "phone") initPhoneField();
    popup.setAttribute("data-step", step);
    var pct = PROGRESS[step] || 0;
    if (progressFill) progressFill.style.width = pct + "%";
    if (progressPct) progressPct.textContent = pct + "%";
    if (step === "result") track("Quiz Popup Result Viewed", { recommendation: recommendation });
  }

  /* The field + answer for the screen currently on-screen (null for screens
     without a question list, e.g. welcome / reveal / phone / result). */
  function currentAnswer() {
    var screen = screens[index];
    var list = screen && screen.querySelector(".fq-options[data-field]");
    if (!list) return null;
    var field = list.getAttribute("data-field");
    var multi = list.getAttribute("data-select") === "multi";
    var picked = Array.prototype.map.call(
      list.querySelectorAll(".fq-option.selected .fq-option__label"),
      function (el) { return el.textContent.trim(); }
    );
    return { field: field, question: QUESTIONS[field] || field, answer: multi ? picked : (picked[0] || null) };
  }

  /* ---- Collect the current answers off the DOM ---- */
  function collectAnswers() {
    var answers = {};
    popup.querySelectorAll(".fq-options[data-field]").forEach(function (list) {
      var field = list.getAttribute("data-field");
      var multi = list.getAttribute("data-select") === "multi";
      var picked = Array.prototype.map.call(
        list.querySelectorAll(".fq-option.selected .fq-option__label"),
        function (el) { return el.textContent.trim(); }
      );
      answers[field] = multi ? picked : (picked[0] || null);
    });
    return answers;
  }

  /* ---- Shape the Klaviyo payload (JSON:API "profile" with custom props) ---- */
  function buildKlaviyoPayload(email, phone, answers) {
    // Question -> answer map so Klaviyo stores the actual questions with responses.
    var responses = {};
    Object.keys(QUESTIONS).forEach(function (field) {
      responses[QUESTIONS[field]] = answers[field];
    });
    return {
      data: {
        type: "profile",
        attributes: {
          email: email,
          phone_number: phone || undefined,
          properties: {
            quiz_popup_moment: answers.moment,
            quiz_popup_priority: answers.priority,
            quiz_popup_supplements: answers.supplements,
            quiz_popup_responses: responses,
            quiz_popup_source: "product-finder",
            quiz_popup_recommendation: recommendation
          }
        }
      }
    };
  }

  /* ---- Send to Klaviyo (or dry-run if no key configured) ---- */
  function submitToKlaviyo(email, phone) {
    var answers = collectAnswers();
    var payload = buildKlaviyoPayload(email, phone, answers);

    if (!KLAVIYO.enabled || !KLAVIYO.publicKey) {
      console.groupCollapsed("[Klaviyo DRY-RUN] submission skipped — payload not sent");
      console.log("email:", email);
      console.log("phone:", phone);
      console.log("answers:", answers);
      console.log("profile payload:", JSON.parse(JSON.stringify(payload)));
      if (KLAVIYO.listId) console.log("would subscribe to list:", KLAVIYO.listId);
      console.groupEnd();
      return Promise.resolve({ dryRun: true, payload: payload });
    }

    var headers = { "Content-Type": "application/json", revision: KLAVIYO.revision };

    /* fetch() only rejects on a network error — a 400/403 resolves normally. Surface
       the body so a malformed profile or a bad key isn't swallowed silently. */
    var check = function (label) {
      return function (res) {
        if (!res || res.ok) return res;
        return res.text().then(function (body) {
          console.error("[Klaviyo] " + label + " failed " + res.status + ":", body);
          return res;
        });
      };
    };

    // 1) Create/append the profile + custom quiz properties (client endpoint).
    var createProfile = fetch(
      "https://a.klaviyo.com/client/profiles/?company_id=" + encodeURIComponent(KLAVIYO.publicKey),
      { method: "POST", headers: headers, body: JSON.stringify(payload) }
    ).then(check("profile"));

    // 2) Subscribe them to the list. Shape matches SubscriptionChannels in the
    //    OpenAPI spec. SMS is only requested where Klaviyo can accept it —
    //    elsewhere the number still lands on the profile, just unsubscribed.
    var wantsSms = !!phone && (KLAVIYO.forceSms || smsSupported());
    var subAttrs = { email: email };
    subAttrs.subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    if (phone) subAttrs.phone_number = phone;
    if (wantsSms) subAttrs.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };
    if (phone && !wantsSms) {
      console.warn("[Klaviyo] SMS not available for this country — subscribing email only");
    }

    var postSubscription = function (attrs) {
      return fetch(
        "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(KLAVIYO.publicKey),
        {
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                custom_source: "Product Finder Quiz",
                profile: { data: { type: "profile", attributes: attrs } }
              },
              relationships: { list: { data: { type: "list", id: KLAVIYO.listId } } }
            }
          })
        }
      );
    };

    /* Backstop: a country can be on Klaviyo's list yet still have no sending
       number provisioned on the account, which rejects the whole subscription
       and takes the email signup with it. Retry email-only in that case. */
    var subscribe = KLAVIYO.listId
      ? postSubscription(subAttrs).then(function (res) {
          if (res.ok || !wantsSms) return check("subscription")(res);
          return res.text().then(function (body) {
            console.warn("[Klaviyo] subscription with SMS failed " + res.status +
                         ", retrying email-only:", body);
            return postSubscription({
              email: email,
              subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } }
            }).then(check("subscription (email-only)"));
          });
        })
      : Promise.resolve(null);

    return Promise.all([createProfile, subscribe]).catch(function (err) {
      console.error("[Klaviyo] submission failed:", err);
    });
  }

  /* ---- Primary action button of the active screen ---- */
  function primaryAction() {
    var el = screens[index].querySelector('[data-action="next"], [data-action="restart"], [data-action="product"]');
    return el;
  }

  /* ---- Advance from the reveal step, gating on a valid email ---- */
  function tryAdvanceFromReveal() {
    var email = (emailInput.value || "").trim();
    if (!EMAIL_RE.test(email)) {
      emailInput.classList.add("is-invalid");
      emailInput.focus();
      return false;
    }
    return true;
  }

  /* ---- Advance from the phone step: validate, score, submit, then reveal ---- */
  function tryAdvanceFromPhone() {
    // SMS is optional: an empty field is allowed (skip). Only block when the
    // shopper typed something that isn't a valid number.
    var typedPhone = (phoneInput && phoneInput.value ? phoneInput.value.trim() : "");
    if (typedPhone && !phoneIsValid()) {
      phoneInput.classList.add("is-invalid");
      var msg = popup.querySelector(".fq-reveal__error");
      if (msg) {
        msg.textContent = phoneError();
        msg.hidden = false;
      }
      phoneInput.focus();
      return false;
    }
    recommendation = scoreRecommendation();   // resolve before we report it
    applyResult();                            // paint the result screen to match
    if (!submitted) {          // submit once
      submitted = true;
      /* Fire-and-forget: a Klaviyo outage must not stop the shopper seeing
         their result. submitToKlaviyo already catches its own fetch errors. */
      try {
        submitToKlaviyo((emailInput.value || "").trim(), phoneValue());
      } catch (e) {
        console.error("[Klaviyo] submission threw:", e);
      }
      markSeen();              // suppress the popup for 30 days on this browser
      /* --- Klaviyo onsite events: phone captured + quiz completed --- */
      var _final = collectAnswers();
      identify({ "$email": (emailInput.value || "").trim(), "$phone_number": phoneValue() });
      track("Quiz Popup Phone Captured", { phone: phoneValue(), country: cachedCountry() });
      track("Quiz Popup Completed", {
        recommendation: recommendation,
        moment: _final.moment,
        priority: _final.priority,
        supplements: _final.supplements
      });
    }
    return true;
  }

  /* ---- Navigation ---- */
  popup.addEventListener("click", function (e) {
    var actionEl = e.target.closest("[data-action]");
    if (actionEl) {
      var action = actionEl.getAttribute("data-action");
      if (action === "next") {
        var _cur = order[index];
        if (_cur === "welcome") {
          track("Quiz Popup Started", { source: location.pathname });
        } else {
          var _ans = currentAnswer();
          if (_ans) track("Quiz Popup Question Answered", { step: _cur, question: _ans.question, answer: _ans.answer });
        }
        if (order[index] === "reveal") {
          if (!tryAdvanceFromReveal()) return;      // email gate only
          identify({ "$email": (emailInput.value || "").trim() });
          track("Quiz Popup Email Captured", { email: (emailInput.value || "").trim() });
          show(index + 1);
          return;
        }
        if (order[index] === "phone") {
          if (revealing) return;                    // animation already running
          if (!tryAdvanceFromPhone()) return;
          revealing = true;
          var phoneScreen = screens[index];
          phoneScreen.classList.add("is-revealing");
          setTimeout(function () {
            phoneScreen.classList.remove("is-revealing");
            revealing = false;
            show(index + 1);
          }, REVEAL_MS);
          return;
        }
        show(index + 1);
      } else if (action === "back") show(index - 1);
      else if (action === "product") {
        track("Quiz Popup Result CTA Clicked", { recommendation: recommendation, url: productUrl() });
        var _dest = productUrl();
        /* Brief flush so the onsite event sends before we navigate away. */
        setTimeout(function () { window.location.href = _dest; }, 120);
      } else if (action === "close" || action === "restart") {
        if (action === "close") closeStage();   // fire "Closed" with the real step, before the reset below
        submitted = false;
        revealing = false;
        popup.querySelectorAll(".is-revealing").forEach(function (s) {
          s.classList.remove("is-revealing");
        });
        show(0);
      }
      return;
    }

    /* ---- Option selection ---- */
    var option = e.target.closest(".fq-option");
    if (option) {
      var list = option.closest(".fq-options");
      if (list.getAttribute("data-select") === "multi") {
        option.classList.toggle("selected");
        /* "I'm new to supplements" is mutually exclusive with the rest. */
        if (option.hasAttribute("data-exclusive")) {
          if (option.classList.contains("selected")) {
            list.querySelectorAll(".fq-option:not([data-exclusive])").forEach(function (o) {
              o.classList.remove("selected");
            });
          }
        } else {
          list.querySelectorAll(".fq-option[data-exclusive]").forEach(function (o) {
            o.classList.remove("selected");
          });
        }
      } else {
        list.querySelectorAll(".fq-option").forEach(function (o) {
          o.classList.toggle("selected", o === option);
        });
      }
      syncContinue(screens[index]);
    }
  });

  /* ---- Enter key submits the active screen's primary button ----
     Skip when a button/link/option is focused so the browser's own
     Enter-activates-the-focused-control behavior isn't fired twice. */
  popup.addEventListener("keydown", function (e) {
    if (e.key !== "Enter") return;
    if (e.target.closest("[data-action], .fq-option")) return;
    var btn = primaryAction();
    if (btn) {
      e.preventDefault();
      btn.click();
    }
  });

  /* Clear the error state as the user types */
  if (emailInput) {
    if (PREFILL_EMAIL && !emailInput.value) emailInput.value = PREFILL_EMAIL;
    emailInput.addEventListener("input", function () {
      emailInput.classList.remove("is-invalid");
    });
  }
  if (phoneInput) {
    phoneInput.addEventListener("input", function () {
      phoneInput.classList.remove("is-invalid");
      var msg = popup.querySelector(".fq-reveal__error");
      if (msg) msg.hidden = true;
    });
  }

  /* Open/close also lock/unlock body scroll so the page behind can't scroll. */
  function openStage() {
    if (!stage) return;
    loadPhoneLib();   // first open kicks off the lazy intl-tel-input fetch
    var wasOpen = stage.classList.contains("is-open");
    stage.classList.add("is-open");
    document.body.classList.add("fon-quiz-open");
    if (!wasOpen) track("Quiz Popup Viewed", { source: location.pathname });
  }
  /* Set while the popup was opened by an explicit user action. Closing one of
     those isn't a dismissal — they never asked to be shown it in the first
     place, so it must not suppress the automatic open elsewhere. */
  var openedManually = false;

  function closeStage() {
    if (!stage) return;
    if (stage.classList.contains("is-open")) {
      track("Quiz Popup Closed", { step: order[index], completed: completed() });
    }
    stage.classList.remove("is-open");
    document.body.classList.remove("fon-quiz-open");
    if (!openedManually) markDismissed();   // also a no-op once completed
    openedManually = false;
  }

  /* Display limits, per browser:
       - completed the quiz -> never show again
       - dismissed it       -> show again after 5 days
     Bump the version suffixes to re-show the popup to everyone. */
  var DONE_KEY      = "fon_quiz_popup_done_v2";      // completed; no expiry
  var DISMISS_KEY   = "fon_quiz_popup_dismissed_v2"; // closed; timestamp
  var DISMISS_MS    = 5 * 24 * 60 * 60 * 1000;       // 5 days

  function completed() {
    try { return localStorage.getItem(DONE_KEY) === "1"; } catch (e) { return false; }
  }
  function recentlyDismissed() {
    try {
      var ts = parseInt(localStorage.getItem(DISMISS_KEY), 10);
      return !!ts && (Date.now() - ts) < DISMISS_MS;
    } catch (e) { return false; }
  }
  function recentlySeen() {
    return completed() || recentlyDismissed();
  }

  /* The cart drawer sets this on <body> while it's open. Never stack the popup
     on top of a shopper who is mid-cart. */
  function cartDrawerOpen() {
    return document.body.classList.contains("body-fon-cart-drawer");
  }
  function markSeen() {   // called on a successful reveal
    try { localStorage.setItem(DONE_KEY, "1"); } catch (e) {}
  }
  function markDismissed() {
    if (completed()) return;   // nothing to re-show anyway
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) {}
  }

  show(0);

  if (stage) {
    /* `data-manual-trigger` (set by the snippet on /pages/homepage-quiz): render
       the popup but never auto-open it. Callers use FonQuiz.open() or click an
       element carrying [data-fon-quiz-open]. Everywhere else it opens 15s after
       load, unless completed (ever) or dismissed in the last 5 days. */
    var manualTrigger = stage.getAttribute("data-manual-trigger") === "true";
    if (!manualTrigger && !recentlySeen()) {
      setTimeout(function () {
        // Re-check on fire, not when the timer was armed — the drawer may have
        // been opened during those 15 seconds.
        if (cartDrawerOpen() || recentlySeen()) return;
        openStage();
      }, 15000);
    }

    stage.addEventListener("click", function (e) {
      if (e.target === stage) closeStage();   // backdrop
    });

    /* Manual triggers always open, regardless of the suppression limits — the
       shopper asked for it. */
    var openManually = function () {
      openedManually = true;
      show(0);
      openStage();
    };

    document.addEventListener("click", function (e) {
      var trigger = e.target.closest("[data-fon-quiz-open]");
      if (!trigger) return;
      e.preventDefault();
      openManually();
    });

    /* URL-hash trigger: a link ending in #quiz opens the quiz (ads / email / nav).
       Explicit deep-link, so it always opens regardless of the suppression limits. */
    var openIfHash = function () {
      if ((window.location.hash || "").toLowerCase() === "#quiz") openManually();
    };
    openIfHash();
    window.addEventListener("hashchange", openIfHash);

    window.FonQuiz = {
      /* Explicit user action — always opens, suppression limits ignored. */
      open: openManually,
      /* Timed/automatic callers — respects "completed" and "dismissed" limits.
         Returns whether it actually opened. */
      autoOpen: function () {
        if (recentlySeen() || cartDrawerOpen() || stage.classList.contains("is-open")) return false;
        show(0);
        openStage();
        return true;
      },
      close: closeStage,
      isOpen: function () { return stage.classList.contains("is-open"); }
    };
  }
})();
